import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";

import "./i18next";
import About from "./pages/About";
import Contact from "./pages/Contact";
import "./assets/styles/styles.scss";
import Shop from "./pages/Shop";
import "bootstrap/dist/css/bootstrap.min.css";
import DoctorDetails from "./pages/DoctorDetails";
import Index3 from "./pages/Home";
import Services from "./pages/Services";
// import "magnific-popup/dist/magnific-popup.css";
import Blog from "./pages/Blog";
import Chatbot from "./components/Chatbot";
import ChatComponent from "./components/ChatComponent";
import ServiceDetails from "./components/ServiceDetails";
import Equipments from "./pages/Equipments";
import NewsDetails from "./pages/BlogDetails";
import { RefProvider } from "./components/ScrollToAppointment";
import Doctors from "./pages/Doctors";

function ScrollToTop() {
  const location = useLocation();
  const isServicePage = location.pathname.includes("service-details");
  useEffect(() => {
    if (!isServicePage) {
      window.scrollTo(0, 0);
    }
  }, [location, isServicePage]);

  return null;
}

function App() {
  const [formData, setFormData] = useState({
    date: "",
    time: "",
    name: "",
    phone: "",
    email: "",
    concern: "",
    status: "requested",
  });
  useEffect(() => {
    const clearAppCache = async () => {
      try {
        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
          console.log("✅ All caches cleared");
        }

        if ("serviceWorker" in navigator) {
          const registrations =
            await navigator.serviceWorker.getRegistrations();
          for (let registration of registrations) {
            await registration.unregister();
            console.log("🗑️ Service worker unregistered");
          }
        }
      } catch (error) {
        console.error("Error clearing cache or unregistering SW:", error);
      }
    };

    clearAppCache();
  }, []);

  const handleSubmit = async (e) => {
    e?.preventDefault();

    const requestedDate = new Date(`${formData.date}T${formData.time}:00`);

    try {
      await addDoc(collection(db, "appointments"), {
        ...formData,
        requestedDate,
        createdAt: new Date(),
      });

      console.log("Appointment added successfully!");

      const response = await fetch(
        "https://us-central1-lakdawalaeyehospital-f9656.cloudfunctions.net/sendEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ...formData, requestedDate }),
        }
      );

      if (response.ok) {
        console.log("Email sent successfully!");
      } else {
        console.error("Failed to send email");
      }

      setFormData({
        name: "",
        concern: "",
        email: "",
        phone: "",
        date: "",
        time: "",
      });
    } catch (error) {
      console.error("Error adding appointment: ", error);
    } finally {
    }
  };
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => {
          console.log(
            "Service Worker registered with scope: ",
            registration.scope
          );
        })
        .catch((error) => {
          console.log("Service Worker registration failed:", error);
        });
    });
  }

  return (
    <Router>
      <RefProvider>
        {/* Scroll to the top when navigating to a new page */}
        <ScrollToTop />

        <Chatbot />
        <div className="content">
          <Routes>
            <Route
              path="/"
              element={
                <Index3
                  formData={formData}
                  setFormData={setFormData}
                  handleSubmit={handleSubmit}
                />
              }
            />
            <Route path="/doctor" element={<Doctors />} />
            <Route
              path="/chatbot"
              element={
                <ChatComponent
                  formData={formData}
                  setFormData={setFormData}
                  handleSubmit={handleSubmit}
                />
              }
            />
            <Route path="/doctor-details" element={<DoctorDetails />} />
            <Route
              path="/services"
              element={
                <Services
                  formData={formData}
                  setFormData={setFormData}
                  handleSubmit={handleSubmit}
                />
              }
            />
            <Route
              path="/equipments"
              element={
                <Equipments
                  formData={formData}
                  setFormData={setFormData}
                  handleSubmit={handleSubmit}
                />
              }
            />
            <Route path="/blog" element={<Blog />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog-details" element={<NewsDetails />} />
            <Route path="/service-details" element={<ServiceDetails />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
          </Routes>
        </div>
      </RefProvider>
    </Router>
  );
}

export default App;
